var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("h3", { attrs: { id: "about-fiber-popin-title" } }, [
      _vm._v("\n        " + _vm._s(_vm.dto.title) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "nav",
      {
        staticClass: "ob1-menu-page ob1-menu-page-fullscreen mb-1",
        staticStyle: { height: "auto !important" },
      },
      [
        _c("ul", { staticClass: "nav ob1-nav-light" }, [
          _c(
            "li",
            { staticClass: "nav-item active", attrs: { id: "nav-advantages" } },
            [
              _c(
                "button",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "aria-current": "page",
                    "data-fiber-popin-tab": "pills-advantages",
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "d-block d-sm-none without-click" },
                    [_vm._v(_vm._s(_vm.dto.advantagesNavMobile))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "d-none d-sm-block without-click" },
                    [_vm._v(_vm._s(_vm.dto.advantagesNavDesktop))]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item", attrs: { id: "nav-steps" } }, [
            _c(
              "button",
              {
                staticClass: "nav-link",
                attrs: { "data-fiber-popin-tab": "pills-steps" },
              },
              [
                _c("span", { staticClass: "d-block d-sm-none without-click" }, [
                  _vm._v(_vm._s(_vm.dto.stepsNavMobile)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-block without-click" }, [
                  _vm._v(_vm._s(_vm.dto.stepsNavDesktop)),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-content tab-content-clear pt-0",
        staticStyle: { border: "0 !important" },
        attrs: { id: "pills-tabContent" },
      },
      [
        _c("div", { attrs: { id: "pills-advantages" } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 px-0" }, [
              _c(
                "ul",
                { staticClass: "items-list row" },
                _vm._l(_vm.dto.advantages, function (advantage) {
                  return _c("li", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "items-list-item" }, [
                      _c("span", {
                        staticClass: "item-icon mb-2",
                        class: advantage.picto,
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-container mb-2" }, [
                        _c("div", { staticClass: "item-text" }, [
                          _c("span", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(advantage.title) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "item-desc" }, [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(advantage.text) +
                                "\n                                        "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "pills-steps", hidden: "" } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 px-0" },
              [
                _c("p", { staticClass: "text-mw pb-2" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.dto.stepsIntro) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.dto.steps, function (step, index) {
                  return _c("div", { staticClass: "d-flex pb-1" }, [
                    _c("div", { staticClass: "flex-shrink-0" }, [
                      _c("picture", { staticClass: "align-self-start me-2" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "34",
                              height: "34",
                              viewBox: "0 0 34 34",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: { fill: "none", "fill-rule": "evenodd" },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "17",
                                    cy: "17",
                                    r: "16.5",
                                    fill: "#FFF",
                                    "fill-rule": "nonzero",
                                    stroke: "#000",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "text",
                                  {
                                    attrs: {
                                      fill: "#000",
                                      "font-family":
                                        "HelveticaNeue-Roman, Helvetica Neue",
                                      "font-size": "16",
                                    },
                                  },
                                  [
                                    _c(
                                      "tspan",
                                      { attrs: { x: "12.552", y: "23" } },
                                      [_vm._v(_vm._s(index + 1))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow-1 ms-1" }, [
                      _c("p", { staticClass: "lead mb-0" }, [
                        _c("strong", [_vm._v(_vm._s(step.title))]),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "m-0",
                        domProps: { innerHTML: _vm._s(step.textHtml) },
                      }),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "alert-container alert-info",
                    attrs: { role: "alert" },
                  },
                  [
                    _c("p", { staticClass: "alert" }, [
                      _c("span", {
                        staticClass: "alert-icon",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ob1-alert-title" }, [
                        _vm._v(_vm._s(_vm.dto.stepsInsertTitle)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "alert-content step-insert-text" },
                      [
                        _c("p", {
                          staticClass: "text-mw pb-0 mb-0",
                          domProps: {
                            innerHTML: _vm._s(_vm.dto.stepInsertTextHtml),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              2
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }